import { render, staticRenderFns } from "./Modal-template.vue?vue&type=template&id=3ff97095&scoped=true&"
import script from "./Modal-template.vue?vue&type=script&lang=js&"
export * from "./Modal-template.vue?vue&type=script&lang=js&"
import style0 from "./Modal-template.vue?vue&type=style&index=0&id=3ff97095&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff97095",
  null
  
)

export default component.exports